import React from "react";

type Listing = {
  displayPSF: string | null;
  accuratePsf: number | null;
  estimatedPsf: number | null;
  status: string | null;
  leaseType: string | null;
};

type Props = {
  leaseType: string | null;
  status: string | null;
  displayPSF?: string | null;
  nhoodPsf?: number;
  small?: boolean;
};

export const Price = ({
  leaseType,
  status,
  displayPSF,
  nhoodPsf,
  small = false,
}: Props) => {
  const isSubleaseOrLicenseAgreement = [
    "SUBLEASE",
    "LICENSE_AGREEMENT",
  ].includes(leaseType || "");

  if (isSubleaseOrLicenseAgreement || (status === "UNAVAILABLE" && !nhoodPsf))
    return small ? (
      <small>Inquire for pricing</small>
    ) : (
      <>Inquire for pricing</>
    );
  if (!displayPSF && status === "UNAVAILABLE" && nhoodPsf)
    return (
      <>
        ~${nhoodPsf} <abbr>psf</abbr>
      </>
    );
  if (!displayPSF)
    return small ? (
      <small>Inquire for pricing</small>
    ) : (
      <>Inquire for pricing</>
    );
  return (
    <>
      {displayPSF} <abbr>psf</abbr>
    </>
  );
};

export const priceSort = (a: Listing, b: Listing, nhoodPsf: string) => {
  const getSortField = ({
    displayPSF,
    accuratePsf,
    estimatedPsf,
    status,
  }: Listing) =>
    !displayPSF && status === "UNAVAILABLE"
      ? nhoodPsf
      : accuratePsf || estimatedPsf || 0;

  const aSort = getSortField(a);
  const bSort = getSortField(b);
  return aSort > bSort ? 1 : -1;
};
